import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { PsvMarker } from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for virtual-tour markers nested under a node —
 * `/vr_psv_nodes/{nodeId}/psv_markers`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { nodeId: <parent node id> }` to bind to a specific parent
 * node.
 */
@Service()
export class VrMarkerApiClient extends BaseApiClient<PsvMarker> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<PsvMarker> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/vr_psv_nodes/{nodeId}/psv_markers`;
  }
}
